import React from 'react'
import { Div, H4 } from 'konsys-ui'
import { theme } from '../../../styles/_variables'

export const CenterContainerMsg = ({ containerProps, children }) => (
  <Div moreStyle={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '200px',
  }} {...containerProps}>
  {
    children
  }
  </Div>
)

export const CenterContainerWentWrongMsg = ({ containerProps, errorMsg }) => (
  <Div moreStyle={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '200px',
  }} {...containerProps}>
    <H4 color={theme.color.lightPaleGrey}>{errorMsg}</H4>
  </Div>
)



// WEBPACK FOOTER //
// ./src/components/common/container-msg/index.jsx